import { render, staticRenderFns } from "./HorarioSillonDoctores.vue?vue&type=template&id=392b2da8&scoped=true"
import script from "./HorarioSillonDoctores.vue?vue&type=script&lang=js"
export * from "./HorarioSillonDoctores.vue?vue&type=script&lang=js"
import style0 from "./HorarioSillonDoctores.vue?vue&type=style&index=0&id=392b2da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b2da8",
  null
  
)

export default component.exports